import { useQuery } from "@tanstack/react-query";
import { AdminOrderService } from "../services/adminOrderService";

export const useAdminOrders = (
  status: string,
  params?: {
    page?: number;
    limit?: number;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  }
) =>
  useQuery({
    queryKey: ["admin-orders", status, params?.page, params?.limit, params?.search, params?.dateFrom, params?.dateTo],
    queryFn: () => AdminOrderService.getAdminOrders(status, params),
    staleTime: 1000, // Consider data fresh for 1 second
    refetchOnWindowFocus: false, // Prevent refetch on window focus
  });
